import { ReactComponent as Logo } from '../../assets/logo-light.svg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <a href="/" className="footer__logo" aria-label="Bill Bates — Home">
          <Logo className="footer__logo-svg" />
        </a>
        <div className="footer__right">
          <a href="/privacy" className="footer__link">Privacy Policy</a>
          <span className="footer__copy">&copy; 2025 Bill Bates</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
